<template>
  <form id="form" v-loading="loading"  role="form" @submit.prevent="onFormSubmit">
      <div class="text-center" v-if="showButtonGenerate">
        <el-button native-type="submit" class="btn btn-info">Generar Referencia</el-button>
      </div>
      <div class="text-center">
        <div class="ml-auto mr-auto p-3">
          <div>
            <div class="reference-payment">
              <h4>{{formData.reference_payment}}</h4>
              <strong>MONTO A PAGAR</strong>
              <br>
              <h5>${{ammount}}</h5>
            </div>
          </div>
          <br>
          <br>
          <span class="title text-center"><h6>INSTRUCCIONES</h6></span>
          <div class="reference-indications">
            <ul class="text-left">
              <li>
                Para generar la Referencia de Pago, presiona el botón Generar Referencia.
              </li>
              <li>
                Realizar el pago por Transferencia Bancaria o en Ventanilla. En ambos casos es indispensable proporcionar la Referencia de Pago generada.
              </li>
              <li>
                Cuando el pago sea realizado, es necesario notificarlo presionando el botón Notificar Pago.
              </li>
            </ul>
          </div>
        </div>
      </div>
  </form>
</template>
<script>
import { MessageBox, Message, Button } from 'element-ui';
import Investments from '@/providers/Investments'
const provider = new Investments()

export default {
  name: 'reference-payment-form',
  components: {
    [Button.name]: Button
  },
  props: [
    'investId',
    'ammount'
  ],
  beforeMount(){
    this.checkReference()
  },
  data: () => ({
      formData: {
        reference_payment: null
      },
      showButtonGenerate: false,
      showButtonNotify: false,
      loading: false
  }),
  methods: {
    checkReference(){
      provider.getReferencePayment(this.investId).then((resp)=> {
        if (resp.data.reference) {
            this.formData.reference_payment = resp.data.reference
            this.showButtonNotify = true
        } else {
            this.showButtonGenerate = true
            this.showButtonNotify = false
        }
        this.loading = false
      }).catch((err)=>{
        Message({ type: 'error', message: 'Datos incorrectos' })
        this.loading = false
      })
    },
    onFormSubmit () {
      provider.generateReferencePayment({id: this.investId}).then((resp)=> {
        this.formData.reference_payment = resp.data.reference
        this.showButtonGenerate = false
        this.showButtonNotify = true
        this.loading = false
        Message({ type: 'success', message: 'Referencia generada', effect: "dark" })
        this.$emit('changed')
      }).catch((err)=>{
        Message({ type: 'error', message: 'Datos incorrectos' })
        this.loading = false
      })
    }
  },
  watch: {
  }
};
</script>
<style scope>
.reference-payment {
  border-style: dashed;
  border-color: gray;
  padding: 3px;
}
.reference-payment h4, .reference-payment h5 , .reference-indications li{
  font-weight: bold;
}
.reference-indications{
  border-style: solid;
  border-color: #4CAF50;
  color:#4CAF50;
  border-width: 1.5px;
  padding: 3px;
  margin-top: 20px;
}
.reference-indications li {
  margin-top: 5px;
}
</style>
